<div class="login-message-container">
  <img src="assets/generalImage/user.svg" loading="lazy" alt="image" />

  <span class="desc" *ngIf="pageName == 'profile'">{{'desc.login.to.view.profile' | translate}}</span>
  <span class="desc" *ngIf="pageName == 'order'">{{'desc.order.no.login' | translate}}</span>
  <span class="desc" *ngIf="pageName == 'reward'">{{'desc.reward.no.login' | translate}}</span>

  <app-button [textButton]="true" [buttonName]="'button.login'" (onClickEvent)="onClickLogin()"></app-button>
</div>
